// packages/web/src/api/hours-entries/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { hoursEntriesAdminWeek, hoursEntriesGet } from "../generated/sdk.gen.ts";
import type { HoursEntriesAdminWeekData } from "../generated/types.gen.ts";
import { queryKeys } from "../query-keys.ts";

type AdminWeekParams = NonNullable<HoursEntriesAdminWeekData["query"]>;

export const adminWeekOptions = (params: AdminWeekParams) =>
  queryOptions({
    queryKey: queryKeys.hoursEntries.adminWeek(params),
    queryFn: async () => {
      const { data, error } = await hoursEntriesAdminWeek({ query: params });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });

export const hoursEntryByIdOptions = (id: string) =>
  queryOptions({
    queryKey: queryKeys.hoursEntries.byId(id),
    queryFn: async () => {
      const { data, error } = await hoursEntriesGet({ path: { id } });
      if (error) throw error;
      return data;
    },
    enabled: !!id,
    staleTime: 30_000,
  });
